import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable, of, Subscription, PartialObserver } from 'rxjs';
import { catchError, map, tap, share, finalize } from 'rxjs/operators';
import { environment } from 'projects/environments/environment';
import { NGXLogger } from 'ngx-logger';
import { ActionResultClass, ResultClass } from '../model/search-result';

const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root'
})
export class DataService {
  protected BaseUrl = environment.APIBaseUrl;

  data: string;
  ErrorJson: JSON;

  constructor(public http: HttpClient, public logger: NGXLogger) { }

  public getData(controller: string, params: any, successCallback: IHttpCallBack, failCallback: IHttpCallBack = null, finalCallback: IHttpCallBack = null) {
    this.http.get<ResultClass>(this.BaseUrl + controller, { headers, params })
      .pipe(
        // map(res => res.data),
        // tap(res => res.status ? console.log(res.message) : '' ),
        catchError(this.handleError<ResultClass>(`get Data Sources error`)),
        finalize(() => { if (finalCallback) { finalCallback(null); } })
      ).subscribe(res => {
        if (successCallback && res && res.Success) {
          successCallback(res.Result);
        } else {
          let msg = res ? res.Message : 'error';
          this.logger.warn('DA1001', 'getData had error: ' + msg);
          if (failCallback) {
            failCallback(res);
          }
        }
      }, err => {
        this.logger.warn('DA1002', err);
      });
  }

  public Download(controller: string, params: any, successCallback: IHttpCallBack, failCallback: IHttpCallBack = null, finalCallback: IHttpCallBack = null) {
    this.http.get(this.BaseUrl + controller, { params, observe: 'response', responseType: 'blob' })
      .pipe(
        catchError(this.handleError<Response>(`download file error`)),
        finalize(() => { if (finalCallback) { finalCallback(null); } })
      )
      .subscribe((res: HttpResponse<any>) => {
        if (successCallback && res.ok && res.status != 204) {
          var blob = res.body;
          var fileName = res.headers.get('Content-Disposition').split(';')[1].split('filename')[1].split('=')[1].trim().replace(/(['"])/g, "");
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) { // for IE
            (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
          } else {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
          }
          successCallback(res);
        } else {
          if (failCallback) {
            const msg = res.status != 204 ? this.ErrorJson : 'no data found.';
            failCallback(msg);
          }
        }
      }, err => {
        this.logger.warn('DA1002', err);
      });
  }

  public addData(controller: string, body: any, successCallback: IHttpCallBack, failCallback: IHttpCallBack = null, finalCallback: IHttpCallBack = null) {
    this.http.post<ResultClass>(this.BaseUrl + controller, body, { headers })
      .pipe(
        catchError(this.handleError<ResultClass>(`add data error`)),
        finalize(() => { if (finalCallback) { finalCallback(null); } })
      )
      .subscribe(res => {
        if (successCallback && res && res.Success) {
          successCallback(res);
        } else {
          let msg = res ? res.Message : 'error';
          this.logger.warn('DA3001', 'addData had error:' + msg);
          if (failCallback) {
            failCallback(res);
          }
        }
      }, err => {
        this.logger.warn('DA3002', err);
      });
  }

  public updateData(controller: string, body: any, successCallback: IHttpCallBack, failCallback: IHttpCallBack = null, finalCallback: IHttpCallBack = null) {
    this.http.put<ResultClass>(this.BaseUrl + controller, body, { headers })
      .pipe(
        catchError(this.handleError<ResultClass>(`update data error`)),
        finalize(() => { if (finalCallback) { finalCallback(null); } })
      )
      .subscribe(res => {
        if (successCallback && res && res.Success) {
          successCallback(res);
        } else {
          let msg = res ? res.Message : 'error';
          this.logger.warn('DA4001', 'updateData had error:' + msg);
          if (failCallback) {
            failCallback(res);
          }
        }
      }, err => {
        this.logger.warn('DA4002', err);
      });
  }

  public DeleteData(controller: string, params: any, successCallback: IHttpCallBack, failCallback: IHttpCallBack = null, finalCallback: IHttpCallBack = null) {
    this.http.delete<ResultClass>(this.BaseUrl + controller, { headers, params })
      .pipe(
        catchError(this.handleError<ResultClass>(`delete data error`)),
        finalize(() => { if (finalCallback) { finalCallback(null); } })
      )
      .subscribe(res => {
        if (successCallback && res && res.Success) {
          successCallback(res);
        } else {
          let msg = res ? res.Message : 'error';
          this.logger.warn('DA5001', 'DeleteData had error: ' + msg);
          if (failCallback) {
            failCallback(res);
          }
        }
      }, err => {
        this.logger.warn('DA5002', err);
      });
  }


  /**
  * Handle Http operation that failed.
  * Let the app continue.
  * @param operation - name of the operation that failed
  * @param result - optional value to return as the observable result
  */
  public handleError<T>(operation = 'operation', result?: T) {
    return (err: any): Observable<T> => {
      this.logger.warn('DA9001', 'handle error');
      //this.ErrorJson = JSON.parse(err.error);
      // TODO: send the error to remote logging infrastructure
      if (!err.error) {
        this.logger.error('DA9001', err);
      } else if (err.error instanceof Blob) {
        var reader = new FileReader();
        let self = this;
        reader.onload = function () {
          self.logger.error('DA9002', reader.result.toString());
        }
        reader.readAsText(err.error);
        return of(err.error as T);
      } else if (err.error.Status)
        return of(err.error as T);
      else {
        let newErr: any = { Message: err.message };
        return of(newErr as T);
      }
    };
  }
}

export interface IHttpCallBack {
  (data: any);
};
